import config from "../config";

export const getCatalogueCDNAssetPath = (asset) =>
  `${config.imageUrlSource.CDN_CATALOGUE}${asset}`;
